import { render, staticRenderFns } from "./CarActivity.vue?vue&type=template&id=289e6c90&scoped=true&"
import script from "./CarActivity.vue?vue&type=script&lang=js&"
export * from "./CarActivity.vue?vue&type=script&lang=js&"
import style0 from "./CarActivity.vue?vue&type=style&index=0&id=289e6c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e6c90",
  null
  
)

export default component.exports